import React from 'react';
import { Compass, Ship, Package, Globe, BookOpen } from 'lucide-react';
import { ArchiveTab } from '../types';
import { JourneyHubSection } from './journey/JourneyHubSection';
import { SuffolkToSouthernSeasSection } from './journey/SuffolkToSouthernSeasSection';
import { EssentialsForNewLandSection } from './journey/EssentialsForNewLandSection';
import { WhyTheyCameSection } from './journey/WhyTheyCameSection';

interface JourneySectionProps {
  currentTab: ArchiveTab;
  onNavigate: (tab: ArchiveTab) => void;
}

export const JourneySection: React.FC<JourneySectionProps> = ({ currentTab, onNavigate }) => {
  return (
    <div className="max-w-4xl mx-auto space-y-8 pb-16 font-sans text-[#2c221e]">
      
      {/* Chapter Sub-Navigation Bar */}
      <nav className="bg-[#f3ede0] p-2 rounded-2xl border border-[#d8ceb9] flex items-center gap-1.5 overflow-x-auto scrollbar-none">
        <button
          onClick={() => onNavigate('journey')}
          className={`px-3.5 py-2 rounded-xl text-xs sm:text-sm font-serif font-bold transition whitespace-nowrap flex items-center gap-1.5 ${
            currentTab === 'journey'
              ? 'bg-[#4a3525] text-amber-100 shadow-sm border border-amber-200/20'
              : 'text-[#2c221e] hover:bg-[#e8dec9]'
          }`}
        >
          <Compass className="w-4 h-4 text-amber-300" />
          <span>The Journey Overview</span>
        </button>

        <button
          onClick={() => onNavigate('journey-suffolk')}
          className={`px-3.5 py-2 rounded-xl text-xs sm:text-sm font-serif font-bold transition whitespace-nowrap flex items-center gap-1.5 ${
            currentTab === 'journey-suffolk'
              ? 'bg-[#4a3525] text-amber-100 shadow-sm border border-amber-200/20'
              : 'text-[#2c221e] hover:bg-[#e8dec9]'
          }`}
        >
          <Ship className="w-4 h-4 text-amber-300" />
          <span>From Suffolk to the Southern Seas</span>
        </button>

        <button
          onClick={() => onNavigate('journey-essentials')}
          className={`px-3.5 py-2 rounded-xl text-xs sm:text-sm font-serif font-bold transition whitespace-nowrap flex items-center gap-1.5 ${
            currentTab === 'journey-essentials'
              ? 'bg-[#4a3525] text-amber-100 shadow-sm border border-amber-200/20'
              : 'text-[#2c221e] hover:bg-[#e8dec9]'
          }`}
        >
          <Package className="w-4 h-4 text-amber-300" />
          <span>Essentials for a new land</span>
        </button>

        <button
          onClick={() => onNavigate('journey-why-they-came')}
          className={`px-3.5 py-2 rounded-xl text-xs sm:text-sm font-serif font-bold transition whitespace-nowrap flex items-center gap-1.5 ${
            currentTab === 'journey-why-they-came'
              ? 'bg-[#4a3525] text-amber-100 shadow-sm border border-amber-200/20'
              : 'text-[#2c221e] hover:bg-[#e8dec9]'
          }`}
        >
          <Globe className="w-4 h-4 text-amber-300" />
          <span>Why they came around the curve of the Earth</span>
        </button>
      </nav>

      {/* Render Active Journey Sub-View */}
      {currentTab === 'journey' && (
        <JourneyHubSection onNavigate={onNavigate} />
      )}

      {currentTab === 'journey-suffolk' && (
        <SuffolkToSouthernSeasSection onNavigate={onNavigate} />
      )}

      {currentTab === 'journey-essentials' && (
        <EssentialsForNewLandSection onNavigate={onNavigate} />
      )}

      {currentTab === 'journey-why-they-came' && (
        <WhyTheyCameSection onNavigate={onNavigate} />
      )}

    </div>
  );
};
